import {BaseModel} from '@/models/base.model';
import {UserModel} from '@/models/user.model';
import moment from 'moment';

export type TimelineInteractionType = 'text' | 'file' | 'any' | null;

export class TimelineModel extends BaseModel {
  constructor(public icon?: string,
              public title?: string,
              public message?: string,
              public interact_with?: TimelineInteractionType,
              public active?: boolean,
              public interaction?: TimelineInteractionModel,
              public start_at?: string,
              public finish_at?: string) {
    super()
  }
}

export class TimelineInteractionModel extends BaseModel {
  constructor(public content?: string,
              public file?: any,
              public user?: UserModel,
              public replies?: TimelineReplyModel[],
              public file_url?: string) {
    super();
  }
}

export class TimelineReplyModel extends BaseModel {
  constructor(public content?: string,
              public user_id?: number,
              public user?: UserModel,
              public interaction_id?: number,
              public is_advisor?: boolean,
              public is_judge?: boolean) {
    super();
  }
}
